import React, { useMemo } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { MaterialReactTable } from "material-react-table";
import { mkConfig, generateCsv, download } from "export-to-csv";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/AddCircle";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TableMaestros from "verticales/TableMaestros.tsx";
import Footer from "examples/Footer";
import UtilModal from "verticales/UtilModal";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import AppLoading from "verticales/AppLoading.tsx";
import { Card } from "@mui/material";
import {
  IconButton,
  Tooltip,
  Box,
  Stack,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import ViewNewEdit from "./ViewNewEdit.js";
import fetchData from "verticales/FetchData";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ",",
  useKeysAsHeaders: true,
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  //width: '500px',
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 54,
  pl: 2,
  pr: 2,
  pt: 0,
  pb: 2,
};

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "ec2-aws-resize";

const Example = (props: any) => {
  const [data, setData] = React.useState([]);
  const [blocking, setBlocking] = React.useState(false);
  const [dataInstance, setDataInstance] = React.useState([]);
  const [msgAction, setMsgAction] = React.useState(context);
  const [openModal, setOpenModal] = React.useState(false);
  const [cuentaSelect, setCuentaSelect] = React.useState({});
  const [rowSelect, setRowSelect] = React.useState({});
  const [openMonitor, setOpenMonitor] = React.useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = React.useState(false);
  const [rowToDelete, setRowToDelete] = React.useState(null);

  const handleOpenMonitor = (row) => {
    setOpenMonitor(true);
    setRowInstanceSelect(row);
  };
  const renderView = () => {
    return (
      <ViewNewEdit
        row={rowSelect}
        handleCloseModal={handleCloseModal}
        dataInstance={dataInstance}
        handleCloseMonitor={handleCloseMonitor}
        cuentaSelect={cuentaSelect}
      />
    );
  };
  const handleOpenModal = (row) => {
    // console.log("hola com oestsas!!!!!");
    setOpenModal(true);
    setRowSelect(row);
  };

  const handleCloseMonitor = async (refresh) => {
    console.log("refresh..........", refresh);
    setOpenMonitor(false);
    if (refresh && refresh === true) {
      await loadList(cuentaSelect);
    }
  };
  const handleCloseModal = async (refresh) => {
    setOpenModal(false);
    if (refresh) {
      await loadList(cuentaSelect);
    }
  };

  const handleClick = async (dataPage) => {
    if (dataPage.newCuentaValue) {
      setCuentaSelect(dataPage.newCuentaValue);
      await loadList(dataPage.newCuentaValue);
    }
  };
  const handleDeleteClick = (row) => {
    setRowToDelete(row);
    setOpenConfirmDelete(true);
  };
  const handleDeleteSuccess = async () => {
    await loadList(cuentaSelect);
  };

  const loadList = async (cuentaSelectSid) => {
    //setMsgAction("cargando");
    const params = {
      account: cuentaSelectSid,
      action: "get",
    };
    setBlocking(true);
    const resp = await fetchData(url, context, params);
    setData(resp.rows);
    setDataInstance(resp.bodyAdd ? resp.bodyAdd.rows : []);
    setBlocking(false);
  };

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  const handleDelete = async () => {
    const params = {
      action: "DELETE",
      object: {
        id: rowToDelete.original ? rowToDelete.original.id : -1,
      },
    };
    setBlocking(true);
    setMsgAction("eliminando");
    let resp = await fetchData(url, context, params);
    setBlocking(false);
    setOpenConfirmDelete(false);
    await loadList(cuentaSelect);
  };

  const columns = useMemo(
    () => [
      { header: "id Instance", accessorKey: "instance_id" },
      { header: "Instancia", accessorKey: "instance_name" },
      { header: "Instance Base", accessorKey: "instance_type_base" },
      { header: "Instance Resize", accessorKey: "instance_type_resize" },
      { header: "Instance B. Resp", accessorKey: "instance_type_base_respaldo" },
      { header: "Instance R. Resp", accessorKey: "instance_type_resize_respaldo" },
      { header: "Hora Base", accessorKey: "hora_base" },
      { header: "Hora Resize", accessorKey: "hora_resize" },
      { header: "Dias", accessorKey: "dias" },
      { header: "Comentario", accessorKey: "comentario" },
      { header: "fe Creacion", accessorKey: "fecha_creacion" },
      { header: "fe actualizacion", accessorKey: "fecha_actualizacion" },
    ],
    []
  );

  const customTableContainerProps = {
    sx: { maxHeight: props.windowHeight - 270 },
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox m={1}>
                  <Autocomplete
                    disablePortal
                    id="cuentas-resize"
                    options={cuentasResize.map((option) => option.title)}
                    renderInput={(params) => <TextField {...params} label="Cuentas-Resize" />}
                    onInputChange={(event, newCuentaValue) => {
                      handleClick({ newCuentaValue });
                    }}
                  />
                </MDBox>
              </Grid>
              {blocking ? (
                <AppLoading titleCustom={"Ec2-Aws_Resize"} />
              ) : (
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox m={1}>
                    <TableMaestros
                      arrayColumns={columns}
                      data={data}
                      handleOpenModal={handleOpenModal}
                      handleDelete={handleDeleteClick}
                      handleDeleteSuccess={handleDeleteSuccess}
                      height={320}
                    />
                  </MDBox>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <UtilModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        renderView={renderView}
      />
      <Dialog open={openConfirmDelete} onClose={() => setOpenConfirmDelete(false)}>
        <DialogTitle>Confirmar Eliminacion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Esta seguro que desea eliminar: ${rowToDelete?.original?.instance_id}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDelete(false)}>No</Button>
          <Button onClick={handleDelete} color="primary">
            Si
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={openMonitor}
        onClose={handleCloseMonitor}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ViewNewEdit
            row={rowSelect}
            dataInstance={dataInstance}
            handleCloseMonitor={handleCloseMonitor}
            cuentaSelect={cuentaSelect}
          />
        </Box>
      </Modal>
    </DashboardLayout>
  );
};

const cuentasResize = [
  { title: "pdn" },
  { title: "pdn-m1" },
  { title: "pdn-m2" },
  { title: "pdn-m3" },
  { title: "pdn-m4" },
  { title: "pdn-m5" },
  { title: "pdn-m6" },
  { title: "zeus" },
  { title: "staging" },
];

export default Example;
